import 'global.css'

import { useState } from 'react'

import { LANDING_BG_IMAGE } from 'constants/assets'
import { SOMETHING_WENT_WRONG } from 'constants/common'
import { isRouteErrorResponse, useRouteError } from 'react-router-dom'
import { Button } from 'uiLib/Button'

function RootBoundary() {
  const error = useRouteError()
  const [errorMsg, setErrorMsg] = useState<string>(SOMETHING_WENT_WRONG)

  const closeWebView = () => {
    if (window?.Android?.closePage) {
      window.Android.closePage()
    }
    if (window?.webkit?.messageHandlers?.closeButtonClicked) {
      window.webkit.messageHandlers.closeButtonClicked?.postMessage('')
    }
  }

  if (isRouteErrorResponse(error)) {
    const errorObject = {
      404: "This page doesn't exist!",
      401: "You aren't authorized to see this",
      503: 'Looks like our API is down',
      418: '🫖',
    }
    const errorMessage =
      errorObject[error.status as keyof typeof errorObject] ||
      SOMETHING_WENT_WRONG
    setErrorMsg(errorMessage)
  }

  return (
    <div
      className="bg-light-maroon flex min-h-screen flex-col items-center justify-center gap-5 bg-cover bg-center bg-no-repeat p-2.5 text-center"
      style={{ backgroundImage: `url(${LANDING_BG_IMAGE})` }}
    >
      <h3 className="text-lg font-bold text-slate-100">{errorMsg}</h3>
      <Button
        variant="primary"
        className="w-1/2 font-bold"
        onClick={closeWebView}
      >
        Go Back
      </Button>
    </div>
  )
}

export default RootBoundary
